import { FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import React, { useState, useEffect } from 'react'

type AtrInputsProps = {
  onATRPeriodChange: (period: number) => void
  onChartTimeframeChange: (timeframe: string) => void
  onChartPeriodChange: (period: number) => void
  atrPeriod: number
  chartTimeframe: string
  chartPeriod: number
}

function AtrInputs(props: AtrInputsProps) {
  const {
    onATRPeriodChange,
    onChartPeriodChange,
    onChartTimeframeChange,
    chartPeriod,
    chartTimeframe,
    atrPeriod,
  } = props

  const [localAtrPeriod, setLocalAtrPeriod] = useState<string | null>(null)
  const [localChartPeriod, setLocalChartPeriod] = useState<string | null>(null)

  // Reset local state when props change externally
  useEffect(() => {
    setLocalAtrPeriod(null)
  }, [atrPeriod])
  useEffect(() => {
    setLocalChartPeriod(null)
  }, [chartPeriod])

  return (
    <>
      <Grid container item spacing={2}>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>ATR period</InputLabel>
            <OutlinedInput
              value={localAtrPeriod !== null ? localAtrPeriod : atrPeriod}
              onChange={(e) => setLocalAtrPeriod(e.target.value)}
              onBlur={() => {
                if (localAtrPeriod !== null) {
                  const parsed = parseFloat(localAtrPeriod)
                  if (!isNaN(parsed)) onATRPeriodChange(parsed)
                  setLocalAtrPeriod(null)
                }
              }}
              type={'number'}
              inputProps={{ min: 1 }}
              label="ATR value"
            />
          </FormControl>
        </Grid>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel>Periodicity for chart</InputLabel>
            <OutlinedInput
              value={localChartPeriod !== null ? localChartPeriod : chartPeriod}
              onChange={(e) => setLocalChartPeriod(e.target.value)}
              onBlur={() => {
                if (localChartPeriod !== null) {
                  const parsed = parseFloat(localChartPeriod)
                  if (!isNaN(parsed)) onChartPeriodChange(parsed)
                  setLocalChartPeriod(null)
                }
              }}
              type={'number'}
              inputProps={{ min: 1 }}
              label="Periodicity for chart"
            />
          </FormControl>
        </Grid>
        <Grid item sm={4} xs={12}>
          <FormControl fullWidth>
            <InputLabel id="atr-chart-timeframe-label">Timeframe for chart</InputLabel>
            <Select
              labelId="atr-chart-timeframe-label"
              value={chartTimeframe}
              onChange={(e) => onChartTimeframeChange(e.target.value)}
              label="Timeframe for chart"
            >
              <MenuItem value="minute">Minute</MenuItem>
              <MenuItem value="hour">Hour</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}

export default AtrInputs
